let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4D4MJ")).then(() => parcelRequire('bucBf'));